/* Copyright (c) 2017 Backpack Health LLC */

/* global window */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import ProfileModel from '../../models/ProfileModel';
import ColorTheme from '../appAuthorized/presenters/ColorTheme.redux';

const ProfileAvatar = props => {
  const { size, fontSize, backgroundAlpha, getBorderColor, imgClassName, isOutline, isMainProfile } = props;
  const { correctiveScaleForStaticText } = window;
  const correctedSize = correctiveScaleForStaticText ? (size * correctiveScaleForStaticText) : size;
  const correctedFontSize = correctiveScaleForStaticText ? (fontSize * correctiveScaleForStaticText) : fontSize;

  if (props.profile.hasAvatarPhoto()) {
    return (
      <ColorTheme colorThemeId={props.profile.getColorThemeId()}>
        {colorTheme => {
          return (
            <div
              className="cmp-profile-avatar"
              style={{ width: `${size}px`, height: `${size}px` }}
            >
              {isOutline && <div style={{ width: `${size + 2}px`, height: `${size + 2}px` }} className="outline border-color-profile-highlight" />}
              <div
                className={props.isActive ? 'avatar-photo is-active' : 'avatar-photo'}
              >
                <FormattedMessage
                  id={isMainProfile ? (props.altText || 'appNav.menu.user.button.hint') : 'appNav.menu.notUser.button.hint'}
                  values={{ string1: props.profile.greetingName() }}
                >
                  {
                    (alt) => {
                      const altText = props.hideText ? '' : alt;
                      return (
                        <img
                          src={props.profile.getAvatarPhotoUrl()}
                          style={{
                            width: `${size}px`,
                            height: `${size}px`,
                            borderColor: getBorderColor ? getBorderColor(colorTheme) : null,
                          }}
                          alt={altText}
                          className={imgClassName}
                        />
                      );
                    }
                  }
                </FormattedMessage>
              </div>
            </div>
          );
        }}
      </ColorTheme>
    );
  } else {
    return (
      <ColorTheme colorThemeId={props.profile.getColorThemeId()}>
        {colorTheme => {
          const backgroundColor = props.baseColor ? colorTheme.baseColorCss(backgroundAlpha) : colorTheme.accentColorCss();
          return (
            <div
              className="cmp-profile-avatar"
              style={{ width: `${size}px`, height: `${size}px` }}
            >
              {isOutline && <div style={{ width: `${size + 2}px`, height: `${size + 2}px` }} className="outline border-color-profile-highlight" />}

              <div className="touch-area-centering">
                <div
                  className={cx(imgClassName, { 'is-active': props.isActive })}
                  style={{
                    borderRadius: size,
                    width: size,
                    height: size,
                    backgroundColor,
                    borderColor: getBorderColor ? getBorderColor(colorTheme) : null,
                  }}
                />
              </div>

              <div
                className="cmp-profile-avatar-initials"
                style={{
                  fontSize: `${correctedFontSize}px`,
                  lineHeight: `${correctedSize}px`,
                  width: `${correctedSize}px`,
                }}
              >
                {props.profile.getInitials()}
              </div>
            </div>
          );
        }}
      </ColorTheme>
    );
  }
};
ProfileAvatar.propTypes = {
  profile: PropTypes.instanceOf(ProfileModel),
  isActive: PropTypes.bool,
  isOutline: PropTypes.bool,
  size: PropTypes.number,
  fontSize: PropTypes.number,
  altText: PropTypes.string,
  imgClassName: PropTypes.string,
  baseColor: PropTypes.bool,
  backgroundAlpha: PropTypes.number,
  getBorderColor: PropTypes.func,
  isMainProfile: PropTypes.bool,
  hideText: PropTypes.bool,
};
ProfileAvatar.defaultProps = {
  size: 34,
  fontSize: 14,
  isOutline: false,
};

export const SelectedProfileAvatar = (props) => (
  <ProfileAvatar
    {...props}
    baseColor
    imgClassName="selectable_selected"
    backgroundAlpha={0.8}
    getBorderColor={(colorTheme) => colorTheme.highlightColorCss(1)}
  />
);

export const UnselectedProfileAvatar = (props) => (
  <ProfileAvatar
    {...props}
    baseColor
    imgClassName="selectable_unselected"
    backgroundAlpha={0.6}
    getBorderColor={(colorTheme) => colorTheme.highlightColorCss(0.3)}
  />
);

export default ProfileAvatar;
